import type { ErrorInfo } from 'react';

export const getErrorBoundaryMetadata = (
  error: Error,
  errorInfo: ErrorInfo,
) => ({
  errorMessage: error.message,
  errorName: error.name,
  componentStack: errorInfo.componentStack,
});
